function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _ from 'lodash';
import SHARED_ROUTES from '../routes';
export function buildBaseRoute() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, isDemo = _ref.isDemo, isKiosk = _ref.isKiosk, isEmbedded = _ref.isEmbedded, isStoreFront = _ref.isStoreFront, isMobileEcommApp = _ref.isMobileEcommApp, dispensary = _ref.dispensary;
    var href, route;
    if (isDemo) {
        href = SHARED_ROUTES.DEMO;
        route = SHARED_ROUTES.DEMO;
    } else if (isKiosk) {
        href = SHARED_ROUTES.KIOSKS;
        route = SHARED_ROUTES.KIOSKS;
    } else if (isEmbedded) {
        href = SHARED_ROUTES.EMBEDDED_MENU;
        route = SHARED_ROUTES.EMBEDDED_MENU;
    } else if (isMobileEcommApp) {
        href = SHARED_ROUTES.MOBILE_ECOMM;
        route = SHARED_ROUTES.MOBILE_ECOMM;
    } else if (isStoreFront) {
        href = SHARED_ROUTES.STORES;
        route = SHARED_ROUTES.STORES;
    } else if (dispensary) {
        href = SHARED_ROUTES.DISPENSARY;
        route = SHARED_ROUTES.DISPENSARY;
    } else {
        href = SHARED_ROUTES.SHOP;
        route = SHARED_ROUTES.SHOP;
    }
    return [
        href,
        route
    ];
}
export function addDispensaryRoutes() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, href = _ref.href, route = _ref.route, dispensary = _ref.dispensary, info = _ref.info;
    if (dispensary && info) {
        href += "/".concat(dispensary.cName).concat(SHARED_ROUTES.INFO);
        route += SHARED_ROUTES.CNAME_INFO;
    } else if (dispensary) {
        href += "/".concat(dispensary.cName);
        route += SHARED_ROUTES.CNAME;
    }
    return [
        href,
        route
    ];
}
export function addProductRoutes(param) {
    var href = param.href, route = param.route, product = param.product;
    var _product_cName, _ref;
    href += "".concat(SHARED_ROUTES.PRODUCT).concat((_ref = (_product_cName = product.cName) !== null && _product_cName !== void 0 ? _product_cName : product.id) !== null && _ref !== void 0 ? _ref : product._id);
    route += SHARED_ROUTES.PRODUCT_ID;
    return [
        href,
        route
    ];
}
export function addMenuSectionRoutes(param) {
    var href = param.href, route = param.route, menuSection = param.menuSection;
    href += "".concat(SHARED_ROUTES.MENU_SECTION).concat(menuSection.id);
    route += SHARED_ROUTES.MENU_SECTION_ID;
    return [
        href,
        route
    ];
}
export function addSpecialsRoutes(param) {
    var href = param.href, route = param.route, id = param.id, currentRoute = param.currentRoute, specialId = param.specialId;
    href += SHARED_ROUTES.SPECIALS;
    route += SHARED_ROUTES.SPECIALS;
    var generatedOfferSubroute = _.includes(id, 'offer');
    var generatedSaleSubroute = _.includes(id, 'sale');
    if (!generatedOfferSubroute && !generatedSaleSubroute && id) {
        href += "/".concat(id || specialId);
        route += SHARED_ROUTES.OFFER_SPECIAL_ID;
    }
    if (generatedOfferSubroute) {
        href += "/".concat(id || specialId);
        route += SHARED_ROUTES.OFFER_SPECIAL_ID;
    } else if (generatedSaleSubroute) {
        href += "/".concat(id || specialId);
        route += SHARED_ROUTES.SALE_SPECIAL_ID;
    }
    if (!id) {
        if (_.includes(currentRoute, 'offer')) {
            href += "".concat(SHARED_ROUTES.OFFER, "/").concat(specialId);
            route += SHARED_ROUTES.OFFER_SPECIAL_ID;
        } else if (_.includes(currentRoute, 'sale')) {
            href += "".concat(SHARED_ROUTES.SALE, "/").concat(specialId);
            route += SHARED_ROUTES.SALE_SPECIAL_ID;
        }
    }
    return [
        href,
        route
    ];
}
export function buildExternalTemplateRoute(param) {
    var routeRoot = param.routeRoot, brands = param.brands, category = param.category, product = param.product, subcategory = param.subcategory, specials = param.specials, collections = param.collections;
    var href = routeRoot;
    if (brands) {
        href += "?dtche[path]=brands&dtche[brands]=".concat(encodeURIComponent(brands));
    } else if (specials) {
        href += "?dtche[path]=specials";
    } else if (product) {
        href += "?dtche[product]=".concat(encodeURIComponent(product.cName || product.id));
    } else if (category && category.key) {
        href += "?dtche[category]=".concat(encodeURIComponent(category.key));
        if (subcategory) {
            href += "?dtche[subcategory]=".concat(encodeURIComponent(subcategory));
        }
    } else if (collections) {
        href += "?dtche[path]=collections/".concat(encodeURIComponent(collections));
    }
    return {
        href: href
    };
}
export function buildStoreFrontRoute(param) {
    var routeRoot = param.routeRoot, brands = param.brands, category = param.category, product = param.product, subcategory = param.subcategory, specials = param.specials, collections = param.collections;
    var href = routeRoot;
    if (brands) {
        href += "".concat(SHARED_ROUTES.BRANDS, "?brands=").concat(encodeURIComponent(brands));
    } else if (specials) {
        href += SHARED_ROUTES.SPECIALS;
    } else if (product) {
        href += SHARED_ROUTES.PRODUCT + encodeURIComponent(product.cName || product.id);
    } else if (category && category.key) {
        href += SHARED_ROUTES.PRODUCTS + encodeURIComponent(category.key);
        if (subcategory) {
            href += "/".concat(encodeURIComponent(subcategory));
        }
    } else if (collections) {
        href += SHARED_ROUTES.COLLECTIONS + encodeURIComponent(collections);
    }
    return {
        href: href
    };
}
export function isStoreFrontRouteRoot(routeRoot) {
    if (!routeRoot || !_.isString(routeRoot)) {
        return false;
    }
    // Normalize the route by removing trailing slashes to prevent split() issues
    var normalizedRoute = routeRoot.replace(/\/+$/, '');
    var splitRoute = _.split(normalizedRoute, '/');
    // Storefront routes have one of two patterns:
    // domain/store/{cName} || domain/stores/{cName}
    return splitRoute.length > 1 && _.includes([
        'stores',
        'store'
    ], splitRoute[splitRoute.length - 2]);
}
export function buildCheckoutRoute(param) {
    var dispensary = param.dispensary, isDemo = param.isDemo, isStoreFront = param.isStoreFront, isEmbedded = param.isEmbedded, isMobileEcommApp = param.isMobileEcommApp;
    var href, route;
    if (isDemo) {
        href = SHARED_ROUTES.DEMO;
        route = SHARED_ROUTES.DEMO;
    } else if (isEmbedded && dispensary) {
        // embedded-menu has its own checkout route
        href = "".concat(SHARED_ROUTES.EMBEDDED_MENU, "/").concat(dispensary.cName);
        route = SHARED_ROUTES.EMBEDDED_MENU_CNAME;
    } else if (isStoreFront && dispensary) {
        // storefront has its own checkout route
        href = "".concat(SHARED_ROUTES.STORES, "/").concat(dispensary.cName);
        route = SHARED_ROUTES.STORES_CNAME;
    } else if (isMobileEcommApp && dispensary) {
        // mobile ecomm has its own checkout route
        href = "".concat(SHARED_ROUTES.MOBILE_ECOMM, "/").concat(dispensary.cName);
        route = SHARED_ROUTES.MOBILE_ECOMM;
    } else if (dispensary === null || dispensary === void 0 ? void 0 : dispensary.cName) {
        href = "".concat(SHARED_ROUTES.DISPENSARY, "/").concat(dispensary.cName);
        route = SHARED_ROUTES.DISPENSARY_CNAME;
    } else {
        href = '';
        route = '';
    }
    href += SHARED_ROUTES.CHECKOUT;
    route += SHARED_ROUTES.CHECKOUT;
    return [
        href,
        route
    ];
}
export function buildHomeRoute() {
    return [
        "/",
        "/"
    ];
}
export function buildDispensariesRoute() {
    return [
        SHARED_ROUTES.DISPENSARIES,
        SHARED_ROUTES.DISPENSARIES
    ];
}
export function addCategoryRoute(param) {
    var href = param.href, route = param.route, category = param.category, subcategory = param.subcategory;
    // maybe we're passed the object, maybe we're passed the key
    var categoryKey = category.key || category;
    var subcategoryKey = (subcategory === null || subcategory === void 0 ? void 0 : subcategory.key) || subcategory;
    if (subcategoryKey) {
        href += "".concat(SHARED_ROUTES.PRODUCTS).concat(categoryKey, "/").concat(subcategoryKey);
        route += SHARED_ROUTES.SUBCATEGORY;
    } else {
        href += "".concat(SHARED_ROUTES.PRODUCTS).concat(categoryKey);
        route += SHARED_ROUTES.PRODUCTS_CATEGORY;
    }
    return [
        href,
        route
    ];
}
/**
 * Create a route and href based on a given UI state
 * @param {{ isDemo: boolean, isKiosk: boolean, isEmbedded: boolean, isStoreFront: boolean, isMobileEcommApp: boolean, dispensary, category: string, subcategory?: string }} options
 */ export function buildCategoryRoute(param) {
    var isDemo = param.isDemo, isKiosk = param.isKiosk, isEmbedded = param.isEmbedded, isStoreFront = param.isStoreFront, isMobileEcommApp = param.isMobileEcommApp, dispensary = param.dispensary, category = param.category, subcategory = param.subcategory;
    var _buildBaseRoute = _sliced_to_array(buildBaseRoute({
        isDemo: isDemo,
        isKiosk: isKiosk,
        isEmbedded: isEmbedded,
        isStoreFront: isStoreFront,
        isMobileEcommApp: isMobileEcommApp,
        dispensary: dispensary
    }), 2), href = _buildBaseRoute[0], route = _buildBaseRoute[1];
    var ref;
    ref = _sliced_to_array(addDispensaryRoutes({
        href: href,
        route: route,
        dispensary: dispensary
    }), 2), href = ref[0], route = ref[1], ref;
    var ref1;
    ref1 = _sliced_to_array(addCategoryRoute({
        href: href,
        route: route,
        category: category,
        subcategory: subcategory
    }), 2), href = ref1[0], route = ref1[1], ref1;
    return [
        href,
        route
    ];
}
